var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 200,
    viewBox: "0 0 414.106 171.502"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "noResults_svg__b",
    x1: 1.287,
    x2: 0.035,
    y1: 0.734,
    y2: 0.87,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#274041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274041",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "noResults_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    d: "M37.369 0 0 24.652l49.873 53.477L245.32 68.24l-79.917-46.486V.001Z",
    "data-name": "Pfad 1109"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1421"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b5c71",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M66.277 94.154h67.6",
    "data-name": "Pfad 1097",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b5c71",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M233.698 94.154h67.6",
    "data-name": "Pfad 1101",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b5c71",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M308.356 94.154h13.961",
    "data-name": "Pfad 1102",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b5c71",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M329.567 94.154h83.539",
    "data-name": "Pfad 1103",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b5c71",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M140.935 94.154h24.394",
    "data-name": "Pfad 1098",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b5c71",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M220.684 94.154h11.609",
    "data-name": "Pfad 1100",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1b5c71",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M172.326 94.154h40.962",
    "data-name": "Pfad 1099",
    opacity: 0.253
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#noResults_svg__a)",
    "data-name": "Gruppe maskieren 106",
    opacity: 0.196,
    transform: "translate(0 93.373)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#noResults_svg__b)",
    d: "M196.069 154.769H0V95.946h127.985l-.157-55.254L198.308 0l68.031 39.535.211 74.542-69.486 40.123.066.573h-1.06Z",
    "data-name": "Vereinigungsmenge 1",
    transform: "translate(37.574 -93.368)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#f7fafa",
    d: "M303.913 39.541 235.882.006l-70.479 40.687.211 74.541 68.031 39.536 70.479-40.691Z",
    "data-name": "Pfad 1096",
    opacity: 0.601
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bfd1d7",
    "data-name": "Gruppe 1417"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.298 42.03a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022l-.005-1.783a1.02 1.02 0 0 0-.507-.878l-1.542-.9a1.016 1.016 0 0 0-1.088 1.715l-1.709.987a1.019 1.019 0 0 0 1.019 1.765l1.794-1.035Z",
    "data-name": "Pfad 1004"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.314 24.572 2.947 1.713a1.019 1.019 0 0 0 1.024-1.762l-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762",
    "data-name": "Pfad 1005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m281.05 28.486 2.947 1.713a1.019 1.019 0 0 0 1.024-1.762l-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762",
    "data-name": "Pfad 1006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.787 32.401 2.947 1.713a1.019 1.019 0 0 0 1.024-1.762l-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762",
    "data-name": "Pfad 1007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m294.523 36.315 2.947 1.713a1.019 1.019 0 0 0 1.024-1.762l-2.947-1.713a1.019 1.019 0 0 0-1.023 1.762Z",
    "data-name": "Pfad 1008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.37 8.913 2.947 1.713a1.019 1.019 0 0 0 1.024-1.762l-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762",
    "data-name": "Pfad 1009"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.578 20.656 2.947 1.713a1.019 1.019 0 0 0 1.024-1.762l-2.947-1.713a1.019 1.019 0 0 0-1.023 1.762Z",
    "data-name": "Pfad 1010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.106 12.827 2.947 1.713a1.019 1.019 0 0 0 1.024-1.762l-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762",
    "data-name": "Pfad 1011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.633 4.998 2.947 1.713a1.019 1.019 0 1 0 1.023-1.762l-2.946-1.713a1.019 1.019 0 1 0-1.023 1.762Z",
    "data-name": "Pfad 1012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.842 16.742 2.947 1.713a1.019 1.019 0 0 0 1.024-1.762l-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762",
    "data-name": "Pfad 1013"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.78 2.793 1.033-.6 1.032.6a1.019 1.019 0 0 0 1.023-1.762l-1.541-.9a1.02 1.02 0 0 0-1.021 0l-1.544.891a1.019 1.019 0 0 0 1.019 1.765Z",
    "data-name": "Pfad 1014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.323 23.107a1 1 0 0 0 .508-.136l.927-.535 2.573 1.5a1.019 1.019 0 0 0 1.024-1.762l-1.562-.908.1-.057a1.019 1.019 0 0 0-1.019-1.765l-3.059 1.766a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.313 19.071a1 1 0 0 0 .509-.136l3.057-1.766a1.019 1.019 0 1 0-1.019-1.765l-3.057 1.765a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.344 31.177a1 1 0 0 0 .508-.136l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765l-3.058 1.766a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1017"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.293 11a1 1 0 0 0 .508-.136l3.058-1.765a1.019 1.019 0 0 0-1.019-1.765L219.782 9.1a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.282 6.964a1 1 0 0 0 .508-.136l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765l-3.058 1.766a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.354 35.213a1 1 0 0 0 .508-.136l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765l-3.058 1.766a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.305 15.036a1 1 0 0 0 .508-.136l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765l-3.058 1.765a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.333 27.143a1 1 0 0 0 .508-.136l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765l-3.058 1.766a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.365 39.248a1 1 0 0 0 .508-.136l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765l-3.058 1.766a1.019 1.019 0 0 0 .51 1.9Z",
    "data-name": "Pfad 1023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.916 52.415a1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016",
    "data-name": "Pfad 1024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.94 60.635a1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016",
    "data-name": "Pfad 1025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.963 68.855a1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016",
    "data-name": "Pfad 1026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.01 85.3a1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016",
    "data-name": "Pfad 1027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.982 77.077a1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016",
    "data-name": "Pfad 1028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.079 109.961a1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016",
    "data-name": "Pfad 1029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.056 101.739a1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016",
    "data-name": "Pfad 1030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.037 93.518a1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016",
    "data-name": "Pfad 1031"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.151 115.362-1.037-.6v-1.2a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022l.005 1.783a1.02 1.02 0 0 0 .507.878l1.541.9a1.019 1.019 0 0 0 1.024-1.762Z",
    "data-name": "Pfad 1032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.831 134.936-2.947-1.712a1.019 1.019 0 0 0-1.023 1.762l2.947 1.713a1.019 1.019 0 0 0 1.024-1.762Z",
    "data-name": "Pfad 1033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228.776 150.595-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762l2.947 1.713a1.019 1.019 0 0 0 1.024-1.762",
    "data-name": "Pfad 1034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.096 131.021-2.947-1.713a1.019 1.019 0 1 0-1.023 1.762l2.947 1.713a1.019 1.019 0 1 0 1.023-1.762",
    "data-name": "Pfad 1035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.308 142.765-2.947-1.712a1.019 1.019 0 1 0-1.024 1.762l2.947 1.712a1.019 1.019 0 0 0 1.024-1.762",
    "data-name": "Pfad 1036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.623 123.192-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762l2.947 1.713a1.019 1.019 0 0 0 1.024-1.762",
    "data-name": "Pfad 1037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.04 146.681-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762l2.947 1.713a1.019 1.019 0 0 0 1.024-1.762",
    "data-name": "Pfad 1038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.887 119.278-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762l2.947 1.713a1.019 1.019 0 0 0 1.024-1.762",
    "data-name": "Pfad 1039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.568 138.851-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762l2.947 1.713a1.019 1.019 0 1 0 1.024-1.762",
    "data-name": "Pfad 1040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.357 127.107-2.947-1.713a1.019 1.019 0 0 0-1.024 1.762l2.947 1.713a1.019 1.019 0 0 0 1.024-1.762",
    "data-name": "Pfad 1041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.63 152.801-.388.224a1 1 0 0 0-.648-.238 1 1 0 0 0-.642.235l-.385-.224a1.019 1.019 0 0 0-1.024 1.762l1.541.9q.019.009.038.016a1 1 0 0 0 .171.071l.063.019a1 1 0 0 0 .239.031 1 1 0 0 0 .238-.031q.031-.009.062-.019a1 1 0 0 0 .17-.07q.019-.007.038-.016l1.544-.892a1.019 1.019 0 0 0-1.019-1.765Z",
    "data-name": "Pfad 1042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.62 148.764-3.058 1.765a1.019 1.019 0 1 0 1.019 1.765l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765Z",
    "data-name": "Pfad 1043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m262.593 136.658-3.058 1.766a1.019 1.019 0 0 0 1.019 1.765l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765",
    "data-name": "Pfad 1044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.536 116.48-3.058 1.765a1.019 1.019 0 1 0 1.019 1.765l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765Z",
    "data-name": "Pfad 1045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.609 144.729-3.058 1.765a1.019 1.019 0 1 0 1.019 1.765l3.058-1.766a1.019 1.019 0 1 0-1.019-1.764",
    "data-name": "Pfad 1046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.567 128.586-3.058 1.766a1.019 1.019 0 0 0 1.019 1.765l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765",
    "data-name": "Pfad 1047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m269.578 132.622-3.058 1.766a1.019 1.019 0 0 0 1.019 1.765l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765",
    "data-name": "Pfad 1048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.557 124.552-3.058 1.766a1.019 1.019 0 0 0 1.019 1.765l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765",
    "data-name": "Pfad 1049"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.599 140.694-3.058 1.766a1.019 1.019 0 0 0 1.019 1.765l3.058-1.765a1.019 1.019 0 0 0-1.019-1.765Z",
    "data-name": "Pfad 1050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.547 120.516-3.058 1.766a1.019 1.019 0 1 0 1.019 1.765l3.058-1.766a1.019 1.019 0 0 0-1.019-1.765",
    "data-name": "Pfad 1051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.536 112.416a1.02 1.02 0 0 0-1.019-1.016 1.02 1.02 0 0 0-1.016 1.022v1.193l-1.033.6a1.019 1.019 0 1 0 1.019 1.765l1.545-.891a1.02 1.02 0 0 0 .509-.885Z",
    "data-name": "Pfad 1052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.467 94.958a1.02 1.02 0 0 0-1.016 1.021l.01 3.6a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.015",
    "data-name": "Pfad 1053"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.444 86.737a1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.021l-.01-3.6a1.01 1.01 0 0 0-1.019-1.017",
    "data-name": "Pfad 1054"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.424 78.516a1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016",
    "data-name": "Pfad 1055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.494 103.178a1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016",
    "data-name": "Pfad 1056"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.354 53.856a1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016",
    "data-name": "Pfad 1057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.33 45.632a1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016",
    "data-name": "Pfad 1058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.377 62.074a1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016",
    "data-name": "Pfad 1059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.401 70.295a1.02 1.02 0 0 0-1.016 1.022l.01 3.6a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022l-.01-3.6a1.02 1.02 0 0 0-1.019-1.016",
    "data-name": "Pfad 1060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.634 46.23-3.083-1.792a1.019 1.019 0 0 0-1.023 1.762l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762Z",
    "data-name": "Pfad 1061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.682 50.325-3.083-1.792a1.019 1.019 0 0 0-1.023 1.762l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762Z",
    "data-name": "Pfad 1062"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.097 55.813a1.02 1.02 0 0 0-.369-1.393l-3.083-1.792a1.019 1.019 0 0 0-1.024 1.762l3.083 1.792a1.02 1.02 0 0 0 1.393-.369",
    "data-name": "Pfad 1063"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.192 64.003a1.02 1.02 0 0 0-.369-1.393l-3.083-1.791a1.019 1.019 0 1 0-1.023 1.762l3.083 1.791a1.02 1.02 0 0 0 1.393-.369Z",
    "data-name": "Pfad 1064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.787 64.914a1.019 1.019 0 0 0-1.024 1.762l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762Z",
    "data-name": "Pfad 1065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.588 42.135-1.489-.865a1.018 1.018 0 0 0-1.176-1.652l-1.031.595a1.02 1.02 0 0 0-.78.5c-.014.025-.022.051-.035.076a1 1 0 0 0-.208.606l.005 1.783a1.02 1.02 0 0 0 1.019 1.016 1.02 1.02 0 0 0 1.016-1.022v-.235l1.653.961a1.019 1.019 0 1 0 1.024-1.762Z",
    "data-name": "Pfad 1066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.834 69.009a1.019 1.019 0 0 0-1.024 1.762l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762Z",
    "data-name": "Pfad 1067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.438 76.437a1.02 1.02 0 0 0-1.392-.373l-3.088 1.783a1.019 1.019 0 1 0 1.019 1.765l3.088-1.783a1.02 1.02 0 0 0 .373-1.392",
    "data-name": "Pfad 1068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.497 72.362a1.02 1.02 0 0 0-1.392-.373l-3.088 1.783a1.019 1.019 0 1 0 1.019 1.765l3.088-1.783a1.02 1.02 0 0 0 .373-1.392",
    "data-name": "Pfad 1069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.881 73.104a1.019 1.019 0 0 0-1.023 1.762l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762Z",
    "data-name": "Pfad 1070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.73 56.061a1.02 1.02 0 0 0-1.391-.373l-3.088 1.783a1.019 1.019 0 0 0 1.019 1.765l3.088-1.783a1.02 1.02 0 0 0 .372-1.392",
    "data-name": "Pfad 1071"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.907 43.835a1.02 1.02 0 0 0-1.392-.373l-3.088 1.783a1.019 1.019 0 0 0 1.019 1.765l3.088-1.783a1.02 1.02 0 0 0 .373-1.392",
    "data-name": "Pfad 1072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.848 47.91a1.02 1.02 0 0 0-1.392-.373l-3.088 1.783a1.019 1.019 0 0 0 1.019 1.765l3.088-1.783a1.02 1.02 0 0 0 .373-1.392",
    "data-name": "Pfad 1073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.79 51.985a1.02 1.02 0 0 0-1.392-.373l-3.088 1.783a1.019 1.019 0 0 0 1.019 1.765l3.088-1.783a1.02 1.02 0 0 0 .373-1.392",
    "data-name": "Pfad 1074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.556 68.286a1.02 1.02 0 0 0-1.392-.373l-3.089 1.783a1.019 1.019 0 0 0 1.019 1.765l3.089-1.783a1.02 1.02 0 0 0 .373-1.392",
    "data-name": "Pfad 1075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.614 64.211a1.02 1.02 0 0 0-1.392-.373l-3.088 1.783a1.019 1.019 0 1 0 1.019 1.765l3.088-1.783a1.02 1.02 0 0 0 .373-1.392",
    "data-name": "Pfad 1076"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.672 60.132a3.4 3.4 0 0 1-.9-1.11l-3.078-1.79a1.019 1.019 0 0 0-1.023 1.762l2.46 1.43-1.939 1.12a1.019 1.019 0 0 0 1.019 1.765l3.089-1.783a1.02 1.02 0 0 0 .372-1.394",
    "data-name": "Pfad 1077"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.145 59.908a1.02 1.02 0 0 0-.369-1.393l-3.083-1.791a1.019 1.019 0 0 0-1.024 1.762l3.083 1.791a1.02 1.02 0 0 0 1.393-.369",
    "data-name": "Pfad 1078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.928 77.205a1.019 1.019 0 0 0-1.023 1.762l3.083 1.792a1 1 0 0 0 .485.134v3.128a1.02 1.02 0 0 0 1.019 1.017 1.02 1.02 0 0 0 1.017-1.021v-3.566a1.02 1.02 0 0 0-1.019-1.017c-.024 0-.046.006-.07.007a1 1 0 0 0-.408-.445Z",
    "data-name": "Pfad 1079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.564 133.938a1.02 1.02 0 0 0 1.017-1.02l-.005-3.566a1.02 1.02 0 0 0-1.019-1.017 1.02 1.02 0 0 0-1.017 1.02l.005 3.566a1.02 1.02 0 0 0 1.019 1.017",
    "data-name": "Pfad 1080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.587 150.239a1.02 1.02 0 0 0 1.017-1.02l-.005-3.566a1.02 1.02 0 0 0-1.019-1.017 1.02 1.02 0 0 0-1.017 1.02l.005 3.566a1.02 1.02 0 0 0 1.019 1.017",
    "data-name": "Pfad 1081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.529 109.486a1.02 1.02 0 0 0 1.017-1.02l-.005-3.566a1.02 1.02 0 0 0-1.019-1.017 1.02 1.02 0 0 0-1.018 1.02l.005 3.566a1.02 1.02 0 0 0 1.02 1.017",
    "data-name": "Pfad 1082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.576 142.088a1.02 1.02 0 0 0 1.018-1.02l-.005-3.566a1.02 1.02 0 0 0-1.019-1.017 1.02 1.02 0 0 0-1.017 1.02l.005 3.566a1.02 1.02 0 0 0 1.018 1.017",
    "data-name": "Pfad 1083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.542 117.635a1.02 1.02 0 0 0 1.017-1.02l-.005-3.566a1.02 1.02 0 0 0-1.019-1.017 1.02 1.02 0 0 0-1.017 1.02l.005 3.566a1.02 1.02 0 0 0 1.019 1.017",
    "data-name": "Pfad 1084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.519 101.335a1.02 1.02 0 0 0 1.017-1.02l-.005-3.566a1.02 1.02 0 0 0-1.019-1.017 1.02 1.02 0 0 0-1.017 1.02l.005 3.566a1.02 1.02 0 0 0 1.019 1.017",
    "data-name": "Pfad 1085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.508 93.185a1.02 1.02 0 0 0 1.017-1.02l-.005-3.566a1.02 1.02 0 0 0-1.019-1.017 1.02 1.02 0 0 0-1.017 1.02l.005 3.566a1.02 1.02 0 0 0 1.019 1.017",
    "data-name": "Pfad 1086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.553 125.787a1.02 1.02 0 0 0 1.017-1.021l-.006-3.566a1.02 1.02 0 0 0-1.019-1.017 1.02 1.02 0 0 0-1.017 1.02l.006 3.566a1.02 1.02 0 0 0 1.019 1.018",
    "data-name": "Pfad 1087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.973 28.94a1.02 1.02 0 0 0 .369 1.393l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762l-3.083-1.792a1.02 1.02 0 0 0-1.393.369",
    "data-name": "Pfad 1088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.647 53.139a1.019 1.019 0 0 0-1.023 1.762l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762Z",
    "data-name": "Pfad 1089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m253.684 50.836-3.083-1.792a1.019 1.019 0 0 0-1.024 1.762l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762",
    "data-name": "Pfad 1090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.067 37.128a1.02 1.02 0 0 0 .369 1.393l3.083 1.792a1.019 1.019 0 1 0 1.024-1.762l-3.083-1.791a1.02 1.02 0 0 0-1.393.368",
    "data-name": "Pfad 1091"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.024 33.032a1.02 1.02 0 0 0 .369 1.393l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762l-3.083-1.792a1.02 1.02 0 0 0-1.393.369",
    "data-name": "Pfad 1092"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.113 41.223a1.02 1.02 0 0 0 .369 1.393l3.083 1.791a1.019 1.019 0 0 0 1.024-1.762l-3.083-1.791a1.02 1.02 0 0 0-1.393.369",
    "data-name": "Pfad 1093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.164 45.318a1.02 1.02 0 0 0 .369 1.393l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762l-3.083-1.792a1.02 1.02 0 0 0-1.393.369",
    "data-name": "Pfad 1094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.926 24.842a1.02 1.02 0 0 0 .369 1.393l3.083 1.792a1.019 1.019 0 0 0 1.024-1.762l-3.083-1.792a1.02 1.02 0 0 0-1.393.369",
    "data-name": "Pfad 1095"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1418",
    transform: "rotate(45.97 85.428 288.969)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.4,
    cy: 33.4,
    r: 33.4,
    fill: "#168db5",
    "data-name": "Ellipse 63",
    opacity: 0.2,
    transform: "translate(1.65 1.65)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68.396 36.917 6.329 52.098a33.6 33.6 0 0 0 6.318 7.724l53.718-13.139a33.2 33.2 0 0 0 2.031-9.766",
    "data-name": "Pfad 1104",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#274041",
    d: "M70.1 35.05a35.051 35.051 0 1 0-38.9 34.834V76.4a1.36 1.36 0 0 0 1.357 1.358h1.005v13.047h-.782a1.58 1.58 0 0 0-1.581 1.58v41.622a1.58 1.58 0 0 0 1.581 1.58h6.142a1.58 1.58 0 0 0 1.581-1.58V92.385a1.58 1.58 0 0 0-1.581-1.58h-.782V77.754h1.005A1.36 1.36 0 0 0 40.5 76.4v-6.726A35.1 35.1 0 0 0 70.1 35.05M35.051 66.8A31.751 31.751 0 1 1 66.8 35.05 31.79 31.79 0 0 1 35.051 66.8",
    "data-name": "Pfad 1105"
  })))));
};
export default SvgNoResults;